import { useState, useEffect } from "react";
import { useDataContext } from "@/context/DataContext";

const WHATSAPP_NUMBER = "966112345678"; // Fallback number
const WHATSAPP_MESSAGE = "مرحباً، أود الاستفسار عن خدمات المركز";

export default function WhatsAppButton() {
  const { clinicInfo, clinicEmergency } = useDataContext();
  const [visible, setVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [pulse, setPulse] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 1200);
    const pulseTimer = setTimeout(() => setPulse(false), 5000);
    return () => {
      clearTimeout(timer);
      clearTimeout(pulseTimer);
    };
  }, []);

  const handleClick = () => {
    // Try to get WhatsApp number from info.phone, fallback to emergency.text or hardcoded
    const number = clinicInfo?.phone || clinicEmergency?.text || WHATSAPP_NUMBER;
    const url = `https://wa.me/${number.replace(/\+/g, "")}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div
      className="fixed bottom-6 left-6 z-50 flex flex-col items-start gap-3 transition-all duration-500"
      style={{ opacity: visible ? 1 : 0, transform: visible ? "translateY(0)" : "translateY(20px)" }}
    >
      {/* Tooltip bubble */}
      <div
        className={`absolute bottom-full left-0 mb-4 transition-all duration-300 origin-bottom-left ${
          showTooltip ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2 pointer-events-none"
        }`}
      >
        <div
          dir="rtl"
          className="bg-white rounded-2xl px-4 py-3 text-sm text-gray-700 font-medium whitespace-nowrap border border-gray-100"
          style={{
            boxShadow: "0 4px 20px rgba(0,0,0,0.10)",
          }}
        >
          <p className="font-bold text-gray-900 text-xs mb-0.5">تواصل معنا عبر واتساب</p>
          <p className="text-gray-400 text-xs">رد سريع خلال دقائق</p>
          <div
            className="absolute -bottom-2 right-5 w-4 h-4 bg-white border-b border-l border-gray-100 -rotate-45"
            style={{ left: "20px", right: "auto" }}
          ></div>
        </div>
      </div>

      {/* Main Button */}
      <button
        onClick={handleClick}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        aria-label="تواصل عبر واتساب"
        className="relative w-14 h-14 flex items-center justify-center rounded-full cursor-pointer transition-all duration-300 hover:-translate-y-1 hover:shadow-xl active:translate-y-0"
        style={{ background: "#25D366", boxShadow: "0 4px 20px rgba(37,211,102,0.45)" }}
      >
        {/* Subtle Pulse */}
        <span
          className="absolute inset-0 rounded-full"
          style={{
            background: "rgba(37,211,102,0.3)",
            animation: "whatsapp-smooth-pulse 2.5s ease-in-out infinite",
          }}
        ></span>
        <i className="ri-whatsapp-line text-white text-3xl relative z-10 transition-transform duration-300 group-hover:scale-110"></i>
      </button>

      <style>{`
        @keyframes whatsapp-smooth-pulse {
          0% { transform: scale(1); opacity: 0.5; }
          50% { transform: scale(1.15); opacity: 0.1; }
          100% { transform: scale(1); opacity: 0.5; }
        }
        @keyframes fadeSlideUp {
          from { opacity: 0; transform: translateY(8px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}
